import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            filter: '',
            categoryForColor: null,
            showCategoryColors: false,
            parentCategory: null,
            allCategories: [],
            categories: []
        }
    },
    methods: {
        load: load,
        deleteCategory: deleteCategory,
        keymonitor: keymonitor,
        openCategoryColors: openCategoryColors,
        addCompany: addCompany,
        editCategory: editCategory,
        showSubCategory: showSubCategory,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        }
    },

    computed: {
        filteredCategories() {
            if(this.parentCategory != null){
                return this.categories.filter(item => {
                    return (item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1);
                }).sort(function(a, b) {
                    return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
                });
            }else{
                return this.categories.filter(item => {
                    return (item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1);
                }).sort(function(a, b) {
                    return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
                });;
            }

            // return this.articles.filter(item => {
            //     return (item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1);
            //         // item.surname.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
            //         // item.username.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
            //         // item.email.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
            //         // item.phone.toLowerCase().indexOf(this.filter.toLowerCase()) > -1) &&
            //
            //
            // })
        }
    },
    created() {
        this.$topnavbar.$on('closeSeeCategoryColors', () => {
            this.categoryForColor = null;
            this.showCategoryColors = false;
        });

        this.$topnavbar.$on('successSeeCategoryColors', () => {
            this.categoryForColor = null;
            this.showCategoryColors = false;
            this.load();
        });


    },

    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.parentCategory = this.$route.query.parent;
        this.role = session.getRole();
        this.load()
    },
    watch: {
        parentCategory: function (val, old){
            this.categories = this.allCategories.filter(e => e.parentCategory === this.parentCategory);
            this.filter = ''
            if(val == null){
                this.$router.push('/article-categories');
            }
        }
    }
}

function openCategoryColors(item){
    this.categoryForColor = item;
    this.showCategoryColors = true;
}


function load() {
    let _self = this;

    AdminApiService.getArticleCategories()
        .then((response) => {
            _self.allCategories = response.data;
            session.saveArticleCategories(_self.allCategories)
            if(_self.parentCategory != null){
                _self.categories =_self.allCategories.filter(e => e.parentCategory === _self.parentCategory);
            }else{
                _self.categories = _self.allCategories.filter(e => e.parentCategory == null)
            }

        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function showSubCategory(item){
    this.$router.push('/article-categories?parent=' + item.name)
    this.parentCategory = item.name
}


function deleteCategory(item) {
    let  _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_to_remove_category')+': ' + item.name +"?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteArticleCategory(item.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno obrisana kategorija', 'success')
                _self.load();
            })
            .catch(error => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });
}

function keymonitor(event) {
    if (event.key === 'Enter') {

    }
}

function editCategory(item){
    let _self = this
    var empty = item.name;
    swal({
        title: _self.parentCategory != null ? LocService.t('label_a_c_edit_sub_for') + ': ' + _self.parentCategory : LocService.t("label_a_c_name"),
        html : '<html><div class="foo">' +
            '<br>' +
            '<input id="swal-input" type="text" placeholder="'+ LocService.t("label_a_c_name") +'" class="input" style="width: 50%; border-radius: 10px; color: white;" value="'+ empty +'" />' +
            '' +
            '<br>'+
            '</div></html>',
        text: "",
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: LocService.t("label_save"),
        customClass: 'swal2-warning'
    }).then(function () {
        var v = document.getElementById('swal-input').value

        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {});

        let model = {
            id: item.id,
            name: v,
            parentCategory: _self.parentCategory,
        }

        AdminApiService.updateArticleCategory(model)
            .then((response) => {
                _self.load()
                swal.close()
            })
            .catch(error => {
                console.log(error)
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });
}

function addCompany() {
    let _self = this
    var empty = ''
    swal({
        title: _self.parentCategory != null ? LocService.t('label_a_c_add_sub_for') + ': ' + _self.parentCategory : LocService.t("label_a_c_name"),
        html : '<html><div class="foo">' +
            '<br>' +
            '<input id="swal-input" type="text" placeholder="'+ LocService.t("label_a_c_name") +'" class="input" style="width: 50%; border-radius: 10px; color: white;" value="'+ empty +'" />' +
            '' +
            '<br>'+
            '</div></html>',
        text: "",
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: LocService.t("label_save"),
        customClass: 'swal2-warning'
    }).then(function () {
        var v = document.getElementById('swal-input').value

        swal({
            title: "",
            text: "",
            type: "",
            // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
            html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: 'swal-custom'
        }, function (selection) {});

        let model = {
            name: v,
            parentCategory: _self.parentCategory,
        }

        AdminApiService.addArticleCategory(model)
            .then((response) => {
                _self.load()
                swal.close()
            })
            .catch(error => {
                console.log(error)
                swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
            })
    });

}


// WEBPACK FOOTER //
// ./src/components/Article/ArticleCategories.js